export const PRIVACY_POLICY_URL = '/privacy-policy'
export const PRIVACY_CENTER_URL = '/privacy'
export const PRIVACY_CONTACT_URL =
  '/help/support_tickets/new?ch=help_center&faq_entry_id=1432&related_only=false&allow_direct=1'
